import { render, staticRenderFns } from "./YinhuaShuiUploader.vue?vue&type=template&id=5efa1d16&scoped=true"
import script from "./YinhuaShuiUploader.vue?vue&type=script&lang=js"
export * from "./YinhuaShuiUploader.vue?vue&type=script&lang=js"
import style0 from "./YinhuaShuiUploader.vue?vue&type=style&index=0&id=5efa1d16&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5efa1d16",
  null
  
)

export default component.exports